var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.575 4.8301L0.175 1.52913C0.0583333 1.41586 0 1.27832 0 1.1165C0 0.954693 0.0583333 0.817152 0.175 0.703883L0.75 0.169903C0.866667 0.0566343 1.00833 0 1.175 0C1.34167 0 1.48333 0.0566343 1.6 0.169903L4 2.5L6.4 0.169903C6.51667 0.0566343 6.65833 0 6.825 0C6.99167 0 7.13333 0.0566343 7.25 0.169903L7.825 0.703883C7.94167 0.817152 8 0.954693 8 1.1165C8 1.27832 7.94167 1.41586 7.825 1.52913L4.425 4.8301C4.30833 4.94337 4.16667 5 4 5C3.83333 5 3.69167 4.94337 3.575 4.8301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.617c43eac6bc4558b94eee669ef3344b.svg";
export { ForwardRef as ReactComponent };